import { render } from "./AddProjectModal.vue?vue&type=template&id=2407649e&scoped=true"
import script from "./AddProjectModal.vue?vue&type=script&lang=js"
export * from "./AddProjectModal.vue?vue&type=script&lang=js"

import "./AddProjectModal.vue?vue&type=style&index=0&id=2407649e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2407649e"]])

export default __exports__